var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRedemption(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.9023 20.0503H17.3723C21.0723 20.0503 21.9923 19.1303 21.9923 15.4303C20.7123 15.4303 19.6823 14.3903 19.6823 13.1203C19.6823 11.8403 20.7123 10.8003 21.9923 10.8003V9.88025C21.9923 6.18025 21.0723 5.26025 17.3723 5.26025H10.9923V12.0503",
    stroke: "#234943",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9936 17.0502V20.0502H8.22356C6.74356 20.0502 5.87357 19.0402 4.91357 16.7202L4.73356 16.2702C5.94356 15.7902 6.53357 14.3902 6.02357 13.1802C5.53357 11.9702 4.14357 11.3902 2.92357 11.8902L2.75357 11.4602C1.31356 7.94018 1.81357 6.71018 5.33357 5.26018L7.97357 4.18018L10.9936 11.5002V14.0502",
    stroke: "#234943",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.16219 20.0503H7.99219",
    stroke: "#234943",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedemption);
export default __webpack_public_path__ + "static/media/redemption.e516f068ae305c0ce900756e1c903640.svg";
export { ForwardRef as ReactComponent };